import { jsx as _jsx } from "react/jsx-runtime";
import { useLayoutEffect, useRef } from 'react';
import { styled } from 'styled-components';
import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef/index.ts';
import { useResizeObserver } from '@/js/libs/hooks/useResizeObserver/index.ts';
import { BaseNotification } from './Base.js';
const Bar = styled.div `
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 100;
`;
const StyledNotification = styled(BaseNotification) `
  width: 100%;
  padding: 12px 16px;
  gap: 12px;
  border-radius: 0;
  border-top: none;
  border-left: none;
  border-right: none;
`;
export const AppBarNotification = ({ onHeightChange, ...props }) => {
    const barRef = useRef(null);
    const reportHeight = useCallbackRef((height) => onHeightChange?.(height));
    const reportResize = useCallbackRef((rect) => reportHeight(rect.height));
    // The observer's first callback updates state outside a React event handler, so it is flushed after
    // the browser has painted — one frame with no offset, which is the overlap this bar has to avoid.
    // A layout effect runs before that paint.
    useLayoutEffect(() => {
        if (barRef.current)
            reportHeight(barRef.current.getBoundingClientRect().height);
    }, [reportHeight]);
    // Keeps the offset in step when the message rewraps. Closing the notification empties this wrapper
    // (Base hides itself while the dismissal request is still in flight), so it reports 0 right away.
    useResizeObserver(barRef, reportResize);
    return (_jsx(Bar, { ref: barRef, children: _jsx(StyledNotification, { ...props, closeable: true, role: 'alert' }) }));
};
